import { defineStore  } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const useCartStore = defineStore('cart', {
  state: () => ({
    items: [],
    onlineCount: 0
  }),

  getters : {
    totalCount : (state) => {
      return state.items.reduce((total, item) => {
          return total + item.quantity
        }, 0)
    },

    totalPrice : (state) => {
      return state.items.reduce((total, item) => {
          return total + (item.currentPrice * item.quantity)
        }, 0)
    },
  },

  actions: {

    setOnlineCount(onlineCount){
      this.onlineCount = onlineCount
    },

    getDishCountByCategory(categoryId){
      return this.items.filter(item => item.categoryId === categoryId).reduce((total, item) => {
          return total + item.quantity
        }, 0)
    },

    // 获取购物车中菜品的数量
    getDishCount(dishId){
      return this.items.filter(item => item.dishId === dishId)[0]?.quantity
    },

    // 添加菜品到购物车
    updateQuantity(dish, quantity){
      const existingItem = this.items.find(item => item.dishId === dish.dishId)
      
      if (existingItem) {
        const newQuantity = existingItem.quantity + quantity
        if(newQuantity > 0){
          existingItem.quantity = newQuantity
        } else {
          // 数量减到 0 或负数时，直接删除该菜品
          const index = this.items.indexOf(existingItem)
          if (index !== -1) this.items.splice(index, 1)
        }
      } else if (quantity > 0) {
        this.items.push({
          ...dish,
          quantity: quantity
        })
      }
    },

    updateCart(item){
      this.items = item
    },
    
    // 清空购物车
    clearCart() {
      this.items = []
    },

    // 提交订单
    async checkout(table){
      const cartDishes = this.items.map(m=>{
        return {
          dishId: m.dishId,
          name: m.name,
          price: m.currentPrice,
          quantity: m.quantity,
          isServed: false
        }
      })
      const p = {
        ...table
        ,orderDetail: JSON.stringify(cartDishes)
      }
      const res = await httpService.post(URL.ORDER_UPDATE, p)
      this.items = []
      return res
    }
  },
});